module.exports = __webpack_public_path__ + "img/crypto-exchange-gold.36b26e01.svg";